<template>
    <v-content class="auth-wincal">
        <!-- logo -->
        <v-row align-content="center" justify="center" no-gutters class="logo">
            <img :src="init.top_logo_image" height="50px" style="width:auto; max-width:100%;" />
        </v-row>
        
        <div class="px-3 mt-10">
            <v-row class="">
                <v-col cols="12" sm="6" class="pb-0">
                    <p class="subtitle-2 font-weight-black ma-0">{{ shopName }}会員カード番号</p>
                    <v-text-field v-model="memberId" label single-line outlined dense></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="pb-0">
                    <p class="subtitle-2 font-weight-black ma-0">電話番号</p>
                    <v-text-field v-model="memberTelNo" single-line outlined dense :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" @click:append="show = !show"></v-text-field>
                </v-col>
            </v-row>

            <div class="pt-6 text-center">
                <v-btn rounded class="maincolor-bg default_button2 large" @click.stop="authWincal()" :disabled="btnDisabledFlg">{{ shopName }}会員カードと連携</v-btn>
                <p class="mt-2 mb-2 text-caption">連携前に既にアプリ上でお客様情報を<br>登録されていた場合、マンテン会員カード入会時の<br>データに上書きされます。</p>
            </div>

            <v-divider class="my-5" v-if="!pushedWincalLinkButton"></v-divider>

            <div class="text-center" v-if="!pushedWincalLinkButton">
                <img src="@/assets/point/wincal_MH_description.jpg" style="width:auto; max-width:100%;"/>
            </div>

            <div class="text-center" v-if="!pushedWincalLinkButton">
                <v-btn rounded class="maincolor-btn2 default_button2 large" @click.stop="registerNewMember()">マンテン会員 新規登録</v-btn>
                <p class="mt-2 mb-2 text-caption">マンテン会員カードをお持ちでない方は<br>こちらより新規会員登録へお進みください。<br>アプリ会員証が発行されます。</p>
            </div>

            <div class="text-center caption" v-if="!pushedWincalLinkButton">
                <p class="mt-1 mb-5 text-caption">マンテン会員ご加入の際には、<br><a class="alink" @click.stop="toExternalurl()">会員プライバシーポリシー</a>をご確認ください。</p>
            </div>

            <div class="text-center" v-if="!pushedWincalLinkButton">
                <v-btn rounded class="maincolor-btn2 default_button2 large" @click.stop="topPage()">同意してゲストモードではじめる</v-btn>
                <p class="mt-2 mb-2 text-caption">マンテン会員の登録を行わずにアプリを<br>利用される方は、こちらよりお進みください。</p>
            </div>

            <div class="text-center caption pt-10" v-if="!pushedWincalLinkButton">
                <p class="mt-2 mb-2 text-caption">本アプリをご利用の際には、<router-link to="/info/rule">利用規約</router-link>をご確認ください。</p>
                <p class="caption" v-if="init.inquiry_mail">
                    <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+init.inquiry_mail">お問い合わせ</a>
                </p>
            </div>

            <p class="text-center" v-if="init.copyright" style="font-size: 12px; margin-top:60px;">© {{init.copyright}} All right reserved.</p>

        </div>

        <v-overlay :value="loading">
            <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
        </v-overlay>

    </v-content>
</template>

<script>
  export default {
    props: {
        pushedWincalLinkButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            memberId: null,
            memberTelNo: "",
            show: false,
            init: [],
            authResult: [],
            routingResult: [],
            loading: false,
            btnDisabledFlg: false,
            shopName: "マンテン"
        };
    },
    mounted () {
      this.init = this.storageGet('*')
    },
    watch: { //init apiが読み込まれたか監視
      '$root.init_flg': 'fetchData',
    },
    methods: {
        fetchData(){ //init apiが読み込まれた場合initに値を入れる
            this.init = this.storageGet('*');
        },
        toExternalurl(){
            //loadingを表示
            this.loading = true
            var tonative_req = {
                'destination': "https://www.manten-hotel.co.jp/privacy/",
                'feature_id': this.routingResult.feature_id, // mypage
                'screen_id': this.routingResult.screen_id,
                'transition_type': 2,
                'transition_info': 'mantenPrivacyPolicyUrl',
                'page_title': "プライバシーポリシー",
            };

            if (!(this.screenTransition(tonative_req))) {
                this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
            }
            // 処理の最後にローディングを終了させる
            this.loading = false
        },
        async authWincal() {
            // 多重処理防止
            if (this.btnDisabledFlg) return

            try {
                //スピナー表示, ボタンdisabled
                this.loading = true
                this.btnDisabledFlg = true

                // 電話番号バリデーション
                if(!this.memberTelNo.match("^[0-9]+$")){
                    this.callDialog("エラー", "有効な電話番号を入力してください。", 3);
                    return;
                }
                
                // 整合性API実行
                // WIncal API戻り値のキーがキャメルケースのため合わせる
                var auth_req = {'user_id': this.init.user_id, 'member_id': this.memberId, 'member_tel_no': this.memberTelNo }
                var auth_res = await this.apiCall('/user/wincal-user-exist', auth_req, 'post');
                this.$set(this, 'authResult', auth_res);

                // エラーハンドリング
                if (!this.authResult) throw "auth_error";
                if (this.authResult.errorInfo.errorCode) throw "auth_error";                

                // ポイント画面から遷移してきた場合、認証成功後にポイント画面に遷移する
                if(this.pushedWincalLinkButton) {
                    this.$router.push({
                        name: 'point-external-wincal'
                    });
                    return;
                }

                // ルーティングAPI実行
                await this.routingApi();

                // 画面遷移
                this.transitScreen();
            } catch(e) {
                if(this.authResult?.errorInfo){
                    this.callDialog('エラー', this.authResult.errorInfo.errorText, 3);
                } else {
                    this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
                }
            } finally {
                // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
                this.loading = false
                this.btnDisabledFlg = false
            }
        },
        async registerNewMember() {
            // 多重処理防止
            if (this.btnDisabledFlg) return;

            try {
                //スピナー表示, ボタンdisabled
                this.loading = true;
                this.btnDisabledFlg = true;

                // ルーティングAPI実行
                await this.routingApi();

                // 画面遷移
                this.transitScreen();                   
            } catch(e) {
                this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
            } finally {
                // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
                this.loading = false
                this.btnDisabledFlg = false
            }
        },
        async wincalAuthApi(){

        },
        async routingApi(){
            var routing_req = { params: {
                'sid': this.init.sid,
                'device_uid': this.init.device_uid,
                'key': this.init.key,
                'device_id': this.init.device_id,
                'os': this.init.os,
                'feature_id': 'mypage',
                'service_cd': this.init.service_cd
            }};
            var routing_res = await this.apiCall('/user/routing', routing_req, 'get');
            this.$set(this, 'routingResult', routing_res);
        },
        async topPage() {
            // 多重処理防止
            if (this.btnDisabledFlg) return;

            try {
                //スピナー表示, ボタンdisabled
                this.loading = true;
                this.btnDisabledFlg = true;

                // ルーティングAPI実行
                await this.routingTopApi();

                // 画面遷移
                this.transitScreen();                   
            } catch(e) {
                this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
            } finally {
                // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
                this.loading = false
                this.btnDisabledFlg = false
            }
        },
        async routingTopApi(){
            var routing_req = { params: {
                'sid': this.init.sid,
                'device_uid': this.init.device_uid,
                'key': this.init.key,
                'device_id': this.init.device_id,
                'os': this.init.os,
                'feature_id': 'top',
                'service_cd': this.init.service_cd
            }};
            var routing_res = await this.apiCall('/user/routing', routing_req, 'get');
            this.$set(this, 'routingResult', routing_res);
        },
        transitScreen(){
            var tonative_req = {
                'destination': this.routingResult.destination,
                'feature_id': this.routingResult.feature_id,
                'screen_id': this.routingResult.screen_id,
                'transition_type': this.routingResult.transition_type,
                'user_id': this.init.user_id,
                'user_name': this.init.user_name,
                'device_uid': this.init.device_uid,
            };

            if (!(this.screenTransition(tonative_req))) {
                this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
            }
        }
    }
  };
</script>

<style scoped>
.large {
    transform: scale(1.1);
}
</style>